export default "__VITE_ASSET__BQVJbjaT__"